export default __webpack_public_path__ + "static/media/group-grid-photos.1d18b47b.png";